export default {
  features: ["germanVatId", "addB2CTag", "documents" ],
  taxRates: [
    { value: 'tax_0', text:"0 %" },
    { value: 'tax_7' , text:"7 %" },
    { value: 'tax_19', text:"19 %" },
    { value: 'tax_95', text: "9 %"}
  ],
  defaultTaxRate: 'tax_19',
  shopUrl: 'https://marktplatz.suedheide-geniessen.de/',
  platformOwner: 'Südheide genießen',
  firebaseConfig: {
    apiKey: 'AIzaSyD7MMJxifqu2Oq2WwytHFR1lBg_J4dXL5I',
    authDomain: 'suedheide-shopify.firebaseapp.com',
    projectId: 'suedheide-shopify',
    storageBucket: 'suedheide-shopify.appspot.com' ,
    messagingSenderId: '62482173968' ,
    appId: '1:62482173968:web:f73afd84d1b565e4c43a95',
    measurementId: 'G-P9937NY3C2'
  },
  apiHost: 'https://shopify-nchk5667ia-ey.a.run.app/',
  regions: [
    'Südheide genießen', 'Hannover'
  ],
  // productCatsExclude: ['Reserviert für Nutzer', 'Quick-Buy Tabelle', 'Alle Produkte'],
  productTagsAllowCustom: false,
  productTags: [
    'Bio',
    'Vegan',
    'Vegetarisch',
    'Glutenfrei',
    'GVO_frei',
    'Freilandhaltung',
    'Weidehaltung',
    'Mobilstall',
    'Strohstall',
    'Außenklimastall',
    'Mutterkuhhaltung',
    'Brudertier',
    'b2c',
    'Endverbraucher',
    'Gewerbekunden',
    'Hannover',
    'Ohne_Zusatzstoffe',
    'Ohne_Palmöl'
  ]
}
